import { hbs } from 'ember-cli-htmlbars';
export default hbs("<NwSiteAuditChecksPage\n  @model={{this.model}}\n  @checkPath=\"dashboard.url.site-audit.view.checks.show\"\n/>")